import {dataConst, elementNameConst, shapeTypeConst} from '../../../conf';
import {nodeCore} from '../../logic';
import {getIcon} from '../../logic/icon';

/**
 * 拓扑插件-自定义字体图标节点
 */
export default {
  name: 'iconFont',
  type: elementNameConst.node,
  options: {
    /**
     * 绘制节点，包含文本
     * @param {Object} cfg 节点的配置项
     * @param {Group} group 图形分组，节点中的图形对象的容器
     * @return {G.Shape} 绘制的图形，通过 node.get('keyShape') 可以获取到
     */
    draw(cfg, group) {

      // 仅渲染图形使用
      cfg.iconUnicode = getIcon(cfg?.iconContent);
      // 处理节点配置中各类自定义参数
      nodeCore.handleNodeAttr(cfg);

      const { backgroundConfig, style, labelCfg: labelStyle } = cfg;
      const conf = nodeCore.handleCommonSizeCompute(cfg.size);
      const shapeWidth = conf.width || 60, shapeHeight = conf.height || 60;

      if (backgroundConfig) {
        const { backgroundType: shapeType, fill, stroke } = backgroundConfig;
        const attr = {fill, stroke};
        if (shapeType === shapeTypeConst.circle) {
          attr.r = Math.round(shapeWidth / 2);
        } else if (shapeType === shapeTypeConst.rect) {
          attr.width = shapeWidth;
          attr.height = shapeHeight;
          attr.radius = 8;

          attr.x = -Math.round(shapeWidth / 2);
          attr.y = -Math.round(shapeHeight / 2);
        }
        group.addShape(shapeType, {
          attrs: {
            x: 0,
            y: 0,
            lineWidth: 1,
            ...attr
          },
          name: 'icon-background-shape',
          draggable: true
        });
      }

      const shapeSize = shapeWidth > shapeHeight ? shapeHeight : shapeWidth;
      const fontSize = backgroundConfig ? shapeSize - Number(shapeSize * 0.25) : shapeSize;
      const keyShape = group.addShape(shapeTypeConst.text, {
        attrs: {
          x: 0,
          y: 0,
          fontFamily: cfg?.iconFontFamily || 'LeTpFont',
          textAlign: 'center',
          textBaseline: 'middle',
          text: cfg?.iconUnicode || cfg?.iconContent || cfg?.text,
          fontSize: Math.round(fontSize),
          ...style
        },
        name: 'icon-image-shape'
      });

      // const labelY = (backgroundStyle ? shapeHeight * 2 : shapeHeight) + (cfg?.labelStyle?.offset || 5);
      const labelY = shapeHeight + labelStyle?.offset - 15;
      group.addShape(shapeTypeConst.text, {
        attrs: {
          x: 0,
          y: labelY,
          textAlign: 'center',
          text: cfg.label,
          ...labelStyle.style
        },
        name: 'icon-label-shape'
      });
      return keyShape;
    },

    /**
     * 更新节点，包含文本
     * @override
     * @param {Object} cfg 节点的配置项
     * @param {Node} node 节点
     */
    update(cfg, node) {

      // 获取容器和数据
      const group = node.getContainer();
      const shapes = group.getChildren();
      if (!shapes || shapes === 0) {
        return;
      }

      const {label} = node.getModel();
      const {fill, opacity, stroke, lineWidth, lineDash, shadowColor, shadowBlur, shadowOffsetX, shadowOffsetY} = cfg.style;
      const {position, offset, style} = cfg.labelCfg;
      const conf = nodeCore.handleCommonSizeCompute(cfg.size);

      // 获取背景图形
      const backgroundShape = group.getFirst();
      if (backgroundShape) {
        backgroundShape.attr({
          fill, opacity, stroke, lineWidth, lineDash, shadowColor, shadowBlur, shadowOffsetX, shadowOffsetY,
          width: conf.width, height: conf.height
        });
      }

      const keyShape = node.getKeyShape();
      if (keyShape) {
        const shapeSize = conf.width > conf.height ? conf.height : conf.width;
        const fontSize = backgroundShape ? shapeSize - Number(shapeSize * 0.25) : shapeSize;
        keyShape.attr({fontSize});
      }

      const labelShape = group.getLast();
      if (labelShape) {
        let x = 0, y = 0;
        const s = 5;
        const bgAttr = backgroundShape.attr();
        const width = bgAttr.width;
        const height = bgAttr.height;
        if (position === dataConst.position.top) {
          y = -height / 2 - offset;
        } else if (position === dataConst.position.left) {
          x = -width - offset;
          y = s;
        } else if (position === dataConst.position.center) {
          y = s + offset;
        } else if (position === dataConst.position.right) {
          x = width + offset;
          y = s;
        } else if (position === dataConst.position.bottom) {
          y = height - 15 + offset;
        }

        const {fill, fontSize, opacity, textAlign, stroke, lineWidth, shadowColor, shadowBlur, shadowOffsetX, shadowOffsetY} = style;
        labelShape.attr({x, y, fill, fontSize, opacity, textAlign, stroke, lineWidth, shadowColor, shadowBlur, shadowOffsetX, shadowOffsetY, text: label});
      }
    },
    /**
     * 设置节点的状态，主要是交互状态，业务状态请在 draw 方法中实现
     * 单图形的节点仅考虑 selected、active 状态，有其他状态需求的用户自己复写这个方法
     * @param {String} name 状态名称
     * @param {Object} value 状态值
     * @param {Node} node 节点
     */
    setState(name, value, node) {
      const group = node.getContainer();
      const stateStyle = nodeCore.handleStateStyle(name, value, node);

      nodeCore.handleStateStyleChange(group?.getFirst(), stateStyle);
      nodeCore.handleStateStyleChange(node.getKeyShape(), stateStyle);
    }
  }

};
